import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const MenuMappingRow = ({ node, depth, totalPages, mappings, onMappingChange }) => {
  const { t } = useTranslation();
  const mapped = mappings[node.id] ?? '';
  const outOfRange = mapped && (mapped < 1 || mapped > totalPages);

  const pageOptions = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
      <div
        className="flex items-center gap-2 py-1.5 pr-2 rounded-md hover:bg-muted/30"
        style={{ paddingLeft: `${depth * 20 + 8}px` }}
      >
        {/* indent indicator */}
        <span className="flex-shrink-0">
          {node.children?.length > 0 ? (
            <Icon name="ChevronRight" size={13} className="text-muted-foreground" />
          ) : (
            <span className="w-3 h-px bg-border inline-block" />
          )}
        </span>

        <span className={`flex-1 text-sm truncate ${outOfRange ? 'text-warning' : 'text-foreground'}`}>
          {node.name}
          {outOfRange && (
            <Icon name="AlertTriangle" size={13} className="inline ml-1 text-warning" />
          )}
        </span>

        <select
          value={mapped}
          onChange={(e) => onMappingChange(node.id, e.target.value ? parseInt(e.target.value) : null)}
          className="text-xs bg-background border border-border rounded px-1.5 py-1 text-foreground w-32 flex-shrink-0"
        >
          <option value="">{t('menuMapping.unassigned')}</option>
          {pageOptions.map((p) => (
            <option key={p} value={p}>
              {t('menuMapping.page', { number: p })}
            </option>
          ))}
        </select>
      </div>

      {node.children?.map((child) => (
        <MenuMappingRow
          key={child.id}
          node={child}
          depth={depth + 1}
          totalPages={totalPages}
          mappings={mappings}
          onMappingChange={onMappingChange}
        />
      ))}
    </>
  );
};

const MenuMappingTree = ({ tree, totalPages, mappings, onMappingChange }) => {
  return (
    <div className="py-1">
      {tree.map((node) => (
        <MenuMappingRow
          key={node.id}
          node={node}
          depth={0}
          totalPages={totalPages}
          mappings={mappings}
          onMappingChange={onMappingChange}
        />
      ))}
    </div>
  );
};

export default MenuMappingTree;
